import { PACK_ROSTER } from '../sim/JKGame_pack'
import { getSouls, isUnlocked, soulCost } from './JKGame_souls'

export interface MetaProgressSummary {
  souls: number
  unlockableCount: number
  lockedSoulCount: number
  nextCost: number | null
  missingForNext: number | null
}

export function getMetaProgressSummary(): MetaProgressSummary {
  const souls = getSouls()
  const lockedSoulCosts = PACK_ROSTER
    .filter((c) => !isUnlocked(c.id))
    .map((c) => soulCost(c.unlock))
    .filter((cost): cost is number => cost !== null)
    .sort((a, b) => a - b)

  const unlockableCount = lockedSoulCosts.filter((cost) => souls >= cost).length
  const nextCost = lockedSoulCosts[0] ?? null
  const missingForNext = nextCost === null ? null : Math.max(0, nextCost - souls)

  return {
    souls,
    unlockableCount,
    lockedSoulCount: lockedSoulCosts.length,
    nextCost,
    missingForNext,
  }
}
